import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon';

interface SideBarAvatarMenuItemProps {
  icon: string;
  endIcon?: string;
  href?: string;
  rel?: string;
  label: string;
  onClick?: () => void;
  route?: string;
  target?: string;
  disabled?: boolean;
}

const SideBarAvatarMenuItem: FC<SideBarAvatarMenuItemProps> = ({
  icon = '',
  endIcon = undefined,
  href = undefined,
  rel = undefined,
  label = '',
  route = '',
  target = undefined,
  onClick = undefined,
  disabled = false,
}) => {
  const navigation = useNavigate();
  const onPreClick = () => {
    if (disabled) return;

    onClick?.();

    if (href) return;

    if (route) {
      navigation(route);
    }
  };

  if (href) {
    return (
      <MenuItem
        className="flex text-cement-500"
        component="a"
        disabled={disabled}
        href={href}
        rel={rel}
        target={target}
        onClick={onPreClick}
      >
        <div className="flex w-full items-center justify-between gap-3">
          <div className="flex items-center">
            <ListItemIcon>
              <Icon className="text-cement-500">{icon}</Icon>
            </ListItemIcon>
            <Typography variant="subtitle1">{label}</Typography>
          </div>
          {endIcon && <Icon className="text-cement-500">{endIcon}</Icon>}
        </div>
      </MenuItem>
    );
  }

  return (
    <MenuItem className="flex text-cement-500" disabled={disabled} onClick={onPreClick}>
      <div className="flex w-full items-center justify-between gap-3">
        <div className="flex items-center">
          <ListItemIcon>
            <Icon className="text-cement-500">{icon}</Icon>
          </ListItemIcon>
          <Typography variant="subtitle1">{label}</Typography>
        </div>
        {endIcon && <Icon className="text-cement-500">{endIcon}</Icon>}
      </div>
    </MenuItem>
  );
};

export default SideBarAvatarMenuItem;
